 import { Routes, Route, useLocation } from 'react-router-dom';
 import { useEffect } from 'react';
 import './App.css';

 //import ProtectedRoute from './Components/ProtectedRoute';

 import Home from './Components/Home';
 import AboutUs from './Components/AboutUs';
 import Insights from './Components/Insights';
 import ContactUs from './Components/ContactUs';
 const ScrollToTop = () => {
   const { pathname } = useLocation();

   useEffect(() => {
     window.scrollTo(0, 0);
   }, [pathname]);

   return null;
 };

 const App = () => (
   <>
     <ScrollToTop />
     <Routes>
     <Route exact path="/" element={<Home />} />
     <Route exact path="/home" element={<Home />} />
     <Route exact path="/aboutus" element={<AboutUs />} />
     <Route exact path="/insights" element={<Insights />} />
     <Route exact path="/contactus" element={<ContactUs />} />
   </Routes>
   </>
 )


// import TestCheck from "./Components/test";
// import { GoogleOAuthProvider } from "@react-oauth/google";

// const App = () => {
//   return (
//     <GoogleOAuthProvider clientId="65624971031-c79iip89339fj189hsosb2ej9atepf83.apps.googleusercontent.com">
//       <TestCheck />
//     </GoogleOAuthProvider>
//   );
// };

 export default App;
